var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 38.8071 11.1929 50 25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 37.5H12.8125V20.7812H18.125V37.5ZM15.4688 18.4375C13.75 18.4375 12.5 17.1875 12.5 15.4687C12.5 13.75 13.9063 12.5 15.4688 12.5C17.1875 12.5 18.4375 13.75 18.4375 15.4687C18.4375 17.1875 17.1875 18.4375 15.4688 18.4375ZM37.5 37.5H32.1875V28.4375C32.1875 25.7813 31.0937 25 29.5312 25C27.9687 25 26.4062 26.25 26.4062 28.5937V37.5H21.0938V20.7812H26.0937V23.125C26.5625 22.0312 28.4375 20.3125 31.0937 20.3125C34.0625 20.3125 37.1875 22.0312 37.1875 27.1875V37.5H37.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.18130cf69ed643fb75aa5062d826067a.svg";
export { ForwardRef as ReactComponent };